module.exports = {
    ClassificationRegulations: 'Indelingsverordeningen',
    EuClassificationRegulations: 'Indelingsverordeningen EU',
    NotAvailableInChosenLanguage: 'De EU-indelingsverordeningen zijn alleen in het Engels en het Nederlands beschikbaar'
};